(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mutiple-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-bm-advisor-chat]');
  if (!trigger) return;
  event.preventDefault();
  if (trigger.getAttribute('aria-busy') === 'true') return;
  trigger.setAttribute('aria-busy', 'true');
  let attempts = 0;
  const openChat = function() {
    const activator = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button[part="activator"]');
    if (activator) {
      if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
      trigger.removeAttribute('aria-busy');
      return;
    }
    if (++attempts < 40) setTimeout(openChat, 250);
    else {
      trigger.removeAttribute('aria-busy');
      window.location.assign('/pages/contact-us');
    }
  };
  openChat();
});

  } catch(e) { console.error(e); }
})();
})();
